import { Component } from '@angular/core';
import { BankDto } from '../../../service/dto';
import { HttpCategoryService } from '../../../service/http-category.service';
import { Router } from '@angular/router';
import { HttpBankService } from '../../../service/http-bank.service';

@Component({
  selector: 'app-bank-list',
  standalone: false,
  templateUrl: './bank-list.component.html',
  styleUrl: './bank-list.component.scss'
})
export class BankListComponent {
	data: BankDto[] = [];
	constructor(private httpService: HttpBankService, private router: Router){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}

	doView(input: BankDto){
		this.router.navigate(['/bank',input.id,'edit']);
	}
}
